import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ConfirmationModal.css';
import ModalDialog from "./ModalDialog";
import TextButton from "../widgets/TextButton";
import { useModal } from "./ModalContainer";
import ButtonBar from "./ButtonBar";
import { globalBlur } from '../helpers/dom';
export const ConfirmationModal = (props) => {
    var _a, _b;
    return (_jsxs(ModalDialog, { show: props.show, title: props.title, closeButton: props.allowDismiss ? 'close' : undefined, minWidth: props.minWidth, className: "confirmationModal", onConfirm: () => { var _a; return (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props, props.onConfirmArg); }, onClose: props.allowDismiss ? props.onDismiss : undefined, children: [props.children, _jsxs(ButtonBar, { className: "full-margin-top", align: "right", children: [props.allowDismiss != false && _jsx(TextButton, { className: "dismiss", type: "minor", focussable: props.sidewayFocus ? 'sideway' : 'flow', onClick: props.onDismiss, label: (_a = props.dismissContent) !== null && _a !== void 0 ? _a : 'Dismiss' }), _jsx(TextButton, { className: "confirm", type: "major", focussable: props.sidewayFocus ? 'sideway' : 'flow', onClick: () => { var _a; return (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props, props.onConfirmArg); }, label: (_b = props.confirmContent) !== null && _b !== void 0 ? _b : 'Confirm' })] })] }));
};
export function useConfirmationModal(props) {
    const [showModal, dismissModal] = useModal(ConfirmationModal, {
        ...props,
        onConfirm,
        onDismiss,
        show: true,
    });
    function onConfirm(propsArg) {
        var _a;
        dismissModal();
        (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props, propsArg);
    }
    function onDismiss() {
        var _a;
        globalBlur();
        dismissModal();
        (_a = props.onDismiss) === null || _a === void 0 ? void 0 : _a.call(props);
    }
    return showModal;
}
;
export default ConfirmationModal;
